export default "__VITE_ASSET__v9rR6YKX__"